import React from 'react';
import PropertyCard from './PropertyCard';

// PropertyCardGrid — responsive grid wrapper for PropertyCard.
// Default breakpoints: 4 cols ≥1200px, 3 cols ≥900px, 2 cols ≥600px,
// 1 col below. The card itself handles its own sizing; this grid
// just lays them out and surfaces the empty + loading states.
//
// Used by every list-style page that wants the unified card layout
// (#147 unification ask): /properties, /saved (SavedParcels), the
// themed screens. Renders <PropertyCard> per row and passes through
// the optional onParcelHover callback so split-view embeds can
// flash the map marker on card hover.
// `renderFooter` (optional (parcel) => ReactNode) is threaded to each
// PropertyCard's `footer` slot. Lets a page attach a per-card affordance
// (e.g. the Research Library's report link + dossier signals, #1134)
// without forking the card. Default undefined → no footer, unchanged.
function PropertyCardGrid({
  parcels = [],
  loading = false,
  emptyMessage = 'No parcels to show.',
  onParcelHover,
  onUnbookmark,
  onFocusOnMap,
  viewedIds,
  renderFooter,
}) {
  if (loading && parcels.length === 0) {
    return (
      <div style={{ padding: 24, textAlign: 'center', color: '#888' }}>
        Loading…
      </div>
    );
  }
  if (!loading && parcels.length === 0) {
    return (
      <div style={{ padding: 24, textAlign: 'center', color: '#888' }}>
        {emptyMessage}
      </div>
    );
  }
  return (
    <div
      className="property-card-grid"
      style={{
        display: 'grid',
        gap: 14,
        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
        padding: 4,
      }}
    >
      {parcels.map((p) => (
        <PropertyCard
          key={`${p.parcel_id}|${p.state || ''}|${p.county || ''}`}
          parcel={p}
          onParcelHover={onParcelHover}
          onUnbookmark={onUnbookmark}
          onFocusOnMap={onFocusOnMap}
          viewed={viewedIds?.has(p.parcel_id) ?? false}
          footer={renderFooter ? renderFooter(p) : undefined}
        />
      ))}
    </div>
  );
}

export default PropertyCardGrid;
